import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import classNames from 'classnames';
import classes from '../create-campaign-flow.module.css';

interface CategorySidebarProps {
  categories: string[];
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

const STATIC_CATEGORIES = [
  { value: 'all', label: 'All templates' },
  { value: 'favorites', label: 'Favorites' },
  { value: 'recent', label: 'Recent' },
];

export default function CategorySidebar({ categories, selectedCategory, onSelectCategory }: CategorySidebarProps) {
  return (
    <Container className={`flex-column gap-4 ${classes.categorySidebar}`}>
      {STATIC_CATEGORIES.map(({ value, label }) => (
        <Button
          key={value}
          clear
          className={classNames(classes.categoryItem, { [classes.active]: selectedCategory === value })}
          onClick={() => onSelectCategory(value)}
        >
          <Text className="L1" design={selectedCategory === value ? 'GlobalIcoText1' : 'GlobalIcoText3'}>
            {label}
          </Text>
        </Button>
      ))}

      {categories.length > 0 && (
        <>
          <Container padding="8px 16px">
            <Text className="L3" design="GlobalIcoText3">
              STYLE
            </Text>
          </Container>

          {categories.map((category) => (
            <Button
              key={category}
              clear
              className={classNames(classes.categoryItem, { [classes.active]: selectedCategory === category })}
              onClick={() => onSelectCategory(category)}
            >
              <Text className="L1" design={selectedCategory === category ? 'GlobalIcoText1' : 'GlobalIcoText3'}>
                {category}
              </Text>
            </Button>
          ))}
        </>
      )}
    </Container>
  );
}
